import './QuizQuestion.css';

function FillInQuestion({ question, answer, onAnswerChange }) {
    const handleInputChange = (e) => {
        onAnswerChange(e.target.value);
    };

    const words = question.text ? question.text.trim().split(/\s+/) : [];
    const blankPos = question.blankPosition ?? null;
    const blankCount = question.correctAnswers?.length ?? 1;

    const hasText = words.length > 0 && blankPos !== null;
    const before = hasText ? words.slice(0, blankPos).join(' ') : '';
    const after = hasText ? words.slice(blankPos + blankCount).join(' ') : '';

    return (
        <div className="fillin-question">
            <h2 className="question-text">{question.questionText}</h2>

            {hasText ? (
                <div className="fillin-text-container">
                    {before && <span className="fillin-text">{before} </span>}
                    <input
                        type="text"
                        className="fillin-input fillin-input-inline"
                        placeholder="…"
                        value={answer || ''}
                        onChange={handleInputChange}
                    />
                    {after && <span className="fillin-text"> {after}</span>}
                </div>
            ) : (
                <div className="fillin-container">
                    <input
                        type="text"
                        className="fillin-input"
                        placeholder="Zadejte vaši odpověď..."
                        value={answer || ''}
                        onChange={handleInputChange}
                    />
                </div>
            )}
        </div>
    );
}

export default FillInQuestion;
